import { AnimatePresence, motion} from 'framer-motion'

//css
import './css/skills.css'
import './css/skill2.css'

//images
import MongoDB from '../images/static/mongodb.png'
import Firebase from '../images/static/firebase.png'
import Postgres from '../images/static/postgres.svg'

const Skill2 = ({ animatinDir, skillCounter }) => {

	return(
				<motion.div 
					initial={animatinDir==="right"?{opacity:0,left:"100%"}:{opacity:0,left:"-100%"}}
					animate={{opacity:1, left:"50%"}}
					transition={{duration:1}}
					exit={animatinDir==="right"?{opacity:0,left:"-50%"}:{opacity:0,left:"100%"}}
					className="skill" 
					id="skill2">
						<div className="skill_head">
							<p>Database</p>
						</div>
						<div className="skill_body" id="skill_2_body">
							<div className="skill_2_body_title">
								<p>i will hook up you backend with one of this databases</p>
							</div>
					
							<div className="dbs_card_container">
								<div>
									<img className="db_icon mongodb_icon" src={MongoDB} alt="" />
								</div>

								<div>
									<img className="db_icon firebase_icon" src={Firebase} alt="" />
								</div>

								<div>
									<img className="db_icon postgres_icon" src={Postgres} alt="" />
								</div>							
								
							</div>
						</div>
						<div className="skill_footer">
							<i className="fas fa-info-circle"></i>always pick the right database for you project
						</div>
				</motion.div>
		)
}

export default Skill2